import { Component, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-import-warning-dialog',
    templateUrl: './import-warning-dialog.component.html',
    styleUrls: ['./import-warning-dialog.component.scss'],
    standalone: false
})
export class ImportWarningDialogComponent extends AbstractDialogComponent {
    @Input() header: string;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'ImportWarning');
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(addMentions: boolean): void {
        this.closeDialog({confirm: true, mentions: addMentions});
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog({confirm: false, mentions: false});
    }
}
